import { render, staticRenderFns } from "./FundsAcquisition.vue?vue&type=template&id=05b586c7&"
import script from "./FundsAcquisition.vue?vue&type=script&lang=ts&setup=true&"
export * from "./FundsAcquisition.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports